import _ from 'lodash'
import { useEffect, useState } from 'react'

const useImagesLoaded = (...sources) => {
  const [loadedSources, setLoadedSources] = useState(new Set())
  const [loaded, setLoaded] = useState(false)
  const hasSources = sources.filter(s => s).length

  useEffect(() => {
    if (!hasSources) {
      setLoaded(true)
      return
    }

    sources.forEach(src => {
      const img = document.createElement('img')

      const onLoad = () => setLoadedSources(prev => new Set(prev).add(src))
      img.onload = onLoad
      img.onerror = err => {
        onLoad()
        console.log(err, src)
      }
      img.src = src
    })
  }, sources)

  useEffect(() => {
    if (hasSources && loadedSources.size === _.uniq(sources).length)
      setLoaded(true)
  }, [sources.length, loadedSources.size])

  return { loaded }
}

export default useImagesLoaded